module.exports = __webpack_public_path__ + "static/media/izlozba (13).cc825448.jpg";